import styled from "styled-components";
import device from "src/constants/media";

export const Wrapper = styled.div`
  position: relative;
  z-index: 10;
`;

export const DaypickerContainer = styled.div`
  position: absolute;
  top: 58px;
  left: -25px;
  z-index: 1;
  box-shadow: 0px 8px 64px -32px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  @media ${device.mobileM} {
    left: -20px;
  }

  @media (min-width: 400px) {
    left: 0;
  }
`;
